module.exports = __webpack_public_path__ + "assets/img/3215.484e1945.svg";